import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminEmailLogs = lazy(() => import("@/pages/admin/AdminEmailLogs"));

export const Route = createFileRoute("/admin/email-logs")({
  component: AdminEmailLogs,
});
